import { Type } from "@shared/ui/Type";

type Props = {
  participantRole: string;
  participantRoleDescription: string;
};

export function VideoUIRoleAndDescription({
  participantRole,
  participantRoleDescription,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Type as="h2" variant="h4" className="flex items-center gap-2">
        Your Role: {participantRole}
      </Type>
      <div className="flex flex-col gap-2">
        {participantRoleDescription && (
          <Type variant="body2">{participantRoleDescription}</Type>
        )}
      </div>
    </div>
  );
}

export default VideoUIRoleAndDescription;
